/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {adminIncrementSyncPosition} from '../api'

export const useMutationAdminIncrementSyncPosition = createReactQueryMutationHook('adminIncrementSyncPosition', adminIncrementSyncPosition)
